import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableModule } from '@schoolbelle/common/table';
import { PhoneNumberModule } from '@schoolbelle/common/phone-number';
import { MemberStatusBadgeModule } from '@schoolbelle/shared/components';
import { VirtualScrollerModule } from 'ngx-virtual-scroller';
import { SelectLetterTargetsAdminOrAllComponent } from './admin-or-all.component';
// import { ReactiveFormsModule, FormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    // FormsModule, ReactiveFormsModule,
  ],
  declarations: [SelectLetterTargetsAdminOrAllComponent],
  exports:[SelectLetterTargetsAdminOrAllComponent],
})
export class SelectLetterTargetsAdminOrAllModule { }
